import { Type } from "class-transformer";
import { Appointment } from "./appointment";
import { User } from "./user";

export abstract class Encounter
{
    constructor(
    public id:number,
    public encounterCreationDate: Date,
    public encounterCompletionDate: Date | undefined = undefined,
    public assignedTo: User | undefined = undefined,
    appointments: Appointment[] = [])
    {
        this.appointments = appointments;
    }

    get displayName() : string
    {
        return this.getDisplayName();
    }


    @Type(() => Appointment)
    appointments: Appointment[] = []

    public abstract getDisplayName() : string;

    public getLatestAppointment(): Appointment | undefined
    {
        if(this.appointments.length === 0)
        {
            return undefined;
        }

        const latestAppointment = this.appointments?.reduce((latest, current) => {
            return current.appointmentDate > latest.appointmentDate ? current : latest;
        }, this.appointments[0]);

        return latestAppointment;
    }
           
}
